
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27 5.25H14a1.001 1.001 0 0 0-1 1v4h-2a1 1 0 0 0-1 1v4H8a1.001 1.001 0 0 0-1 1v4H5a1.001 1.001 0 0 0-1 1v4.5a1.001 1.001 0 0 0 1 1h13.857a1.007 1.007 0 0 0 .862-.492L28 12.205V6.25a1.001 1.001 0 0 0-1-1Zm-12.5 1.5h8.75v3.5H14.5v-3.5Zm-3 5h8.75v3.5H11.5v-3.5Zm-3 5h8.75v3.5H8.5v-3.5Zm-3 5h8.75v3.5H5.5v-3.5Zm21-9.955L18.572 25.25H15.75v-3.5h2a1 1 0 0 0 1-1v-4h2a1 1 0 0 0 1-1v-4h2a1 1 0 0 0 1-1v-4h1.75v5.045Z"}})])
          )
        }
      }
    